import TableCard from "../../components/TableCard";
import styles from "./styles.module.css";
import SettingsIcon from "@mui/icons-material/Settings";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import {
  buscarParametroPorTexto,
  buscarTodosParametros,
  editarParametro,
  inserirParametros,
} from "../../services/auth.service";
import MensagemErro from "../../components/MensagemErro";
import MensagemSucesso from "../../components/MensagemSucesso";
import { debounce } from "lodash";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import WhiteButton from "../../components/WhiteButton";
import BlueButton from "../../components/BlueButton";

const Parametros = () => {
  //#region --- useStates --------
  const [loading, setLoading] = useState(false);
  const [dataResponse, setDataResponse] = useState();
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [msg, setMsg] = useState("");
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openModalNew, setOpenModalNew] = useState(false);
  const [formEditData, setFormEditData] = useState();
  const [formNewData, setFormNewData] = useState();
  const [errorNew, setErrorNew] = useState({ chave: false, valor: false });
  const [errorEdit, setErrorEdit] = useState({ chave: false, valor: false });

  //#endregion

  //#regio ----- Modal ---------
  const handleOpenModalEdit = (idParametro, chave, valor) => {
    setFormEditData({ idParametro: idParametro, chave: chave, valor: valor });
    setOpenModalEdit(true);
  };

  const handleCloseModalEdit = () => {
    setFormEditData();
    setOpenModalEdit(false);
    setErrorEdit({ chave: false, valor: false });
  };

  const handleOpenModalNew = () => {
    setOpenModalNew(true);
  };

  const handleCloseModalNew = () => {
    setFormNewData();
    setOpenModalNew(false);
    setErrorNew({ chave: false, valor: false });
  };
  //#endregion

  //#region ---- snackBar --------

  //Erro
  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  //Sucesso
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  //#endregion

  //#region --- TableCard Conf. -------

  const columns = ["Chave", "Valor"];

  const handleOrganizaData = (data) => {
    const responses = data.map((response) => {
      return {
        chave: response.chave,
        valor: response.valor,
        botoes: [
          {
            icon: <EditIcon />,
            title: "EDITAR",
            onClick: () => {
              handleOpenModalEdit(
                response.idParametro,
                response.chave,
                response.valor
              );
            },
          },
        ],
      };
    });
    return responses;
  };

  useEffect(() => {
    const fetchParametros = async () => {
      try {
        const responseParametros = await buscarTodosParametros();
        setDataResponse(handleOrganizaData(responseParametros.parametros));
        setLoading(true);
      } catch (error) {
        setLoading(false);
        setMsg(error.responseParametros.data.mensagem);
        handleOpenSnackbarErro();
      }
    };

    fetchParametros();
  }, []);

  const handleSearchByText = async (value) => {
    const searchText = value;
    try {
      const responseBusca = await buscarParametroPorTexto(searchText);
      const responseOrganizada = handleOrganizaData(responseBusca.busca);
      setDataResponse(responseOrganizada);
    } catch (error) {
      setMsg(error.mensagem);
      handleOpenSnackbarErro();
    }
  };
  const debouncedHandleChange = debounce(handleSearchByText, 500);
  //#endregion

  //#region -------- HandleChange ---------
  const handleChange = (event) => {
    const { name, value } = event.target;

    let formType = "";

    if (name.startsWith("edit")) {
      formType = "edit";
    } else {
      formType = "new";
    }

    switch (formType) {
      case "edit":
        setFormEditData((prevFormData) => {
          switch (name) {
            case "editID":
              return { ...prevFormData, idParametro: value };
            case "editChave":
              value
                ? setErrorEdit({ ...errorEdit, chave: false })
                : setErrorEdit({ ...errorEdit, chave: true });
              const chaveFormated = value.replace(/ /g, "-");
              return { ...prevFormData, chave: chaveFormated };
            case "editValor":
              value
                ? setErrorEdit({ ...errorEdit, valor: false })
                : setErrorEdit({ ...errorEdit, valor: true });
              return { ...prevFormData, valor: value };

            default:
              return prevFormData;
          }
        });
        break;
      case "new":
        setFormNewData((prevFormData) => {
          switch (name) {
            case "newChave":
              value
                ? setErrorNew({ ...errorNew, chave: false })
                : setErrorNew({ ...errorNew, chave: true });
              const chaveFormated = value.replace(/ /g, "-").toLowerCase();
              return { ...prevFormData, chave: chaveFormated };
            case "newValor":
              value
                ? setErrorNew({ ...errorNew, valor: false })
                : setErrorNew({ ...errorNew, valor: true });
              return { ...prevFormData, valor: value };

            default:
              return prevFormData;
          }
        });
        break;
      default:
        break;
    }
  };

  //#endregion

  //#region ------ Submit ----------

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (formEditData) {
        if (formEditData.chave && formEditData.valor) {
          const body = {
            chave: formEditData.chave,
            valor: formEditData.valor,
          };
          const idParametro = formEditData.idParametro;
          const editParametro = await editarParametro(idParametro, body);

          setMsg(editParametro.mensagem);
          handleOpenSnackbarSucesso();
          handleCloseModalEdit();
        } else {
          if (!formEditData.chave) {
            setErrorEdit({ ...errorEdit, chave: true });
            setMsg("É necessário uma chave");
            handleOpenSnackbarErro();
          } else {
            setErrorEdit({ ...errorEdit, valor: true });
            setMsg("É necessário um valor");
            handleOpenSnackbarErro();
          }
        }
      } else {
        if (formNewData.chave && formNewData.valor) {
          const body = {
            chave: formNewData.chave,
            valor: formNewData.valor,
          };
          const newParametro = await inserirParametros(body);
          setMsg(newParametro.mensagem);
          handleOpenSnackbarSucesso();
          handleCloseModalNew();
        } else {
          if (!formNewData.chave) {
            setErrorNew({ ...errorNew, chave: true });
            setMsg("É necessário uma chave");
            handleOpenSnackbarErro();
          } else {
            setErrorNew({ ...errorNew, valor: true });
            setMsg("É necessário um valor");
            handleOpenSnackbarErro();
          }
        }
      }

      const reloadResponse = await buscarTodosParametros();
      setDataResponse(handleOrganizaData(reloadResponse.parametros));
    } catch (error) {
      setMsg(error.response.data.mensagem);
      handleOpenSnackbarErro();
    }
  };
  //#endregion

  //#region -------- mediaQuery ---------

  const [viewport, setViewport] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setViewport({ width: window.innerWidth });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  //#endregion

  return (
    <>
      {/*Modal novo parmetro*/}
      <Dialog
        open={openModalNew}
        onClose={handleCloseModalNew}
        PaperProps={{
          style: {
            width: viewport.width < 770 ? "80vw" : "30vw",
          },
        }}
      >
        <DialogTitle>Novo Parâmetro</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <div className={styles.container}>
              <TextField
                error={errorNew.chave}
                name="newChave"
                value={formNewData?.chave}
                size="small"
                label="Chave"
                onChange={handleChange}
              />
              <TextField
                error={errorNew.valor}
                name="newValor"
                value={formNewData?.valor}
                size="small"
                label="Valor"
                onChange={handleChange}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <div className={styles.btnContainer}>
              <WhiteButton
                textValue="Cancelar"
                clickFunction={handleCloseModalNew}
              />
              <BlueButton textValue="Salvar" type="submit" />
            </div>
          </DialogActions>
        </form>
      </Dialog>

      {/*Modal edit parâmetro*/}
      <Dialog
        open={openModalEdit}
        onClose={handleCloseModalEdit}
        PaperProps={{
          style: {
            width: viewport.width < 770 ? "80vw" : "30vw",
          },
        }}
      >
        <DialogTitle>Editar Parâmetro</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <div className={styles.container}>
              <div className={styles.line__containerModal}>
                <TextField
                  name="editID"
                  sx={{ width: "3rem" }}
                  disabled
                  value={formEditData?.idParametro}
                  onChange={handleChange}
                  size="small"
                  label="ID"
                />
                <TextField
                  error={errorEdit.chave}
                  fullWidth
                  name="editChave"
                  value={formEditData?.chave}
                  size="small"
                  label="Chave"
                  onChange={handleChange}
                />
              </div>

              <TextField
                error={errorEdit.valor}
                name="editValor"
                value={formEditData?.valor}
                size="small"
                label="Valor"
                onChange={handleChange}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <div className={styles.btnContainer}>
              <WhiteButton
                textValue="Cancelar"
                clickFunction={handleCloseModalEdit}
              />
              <BlueButton textValue="Salvar" type="submit" />
            </div>
          </DialogActions>
        </form>
      </Dialog>

        <TableCard
          iconHeader={<SettingsIcon fontSize="1rem" />}
          titleHeader="Parâmetros"
          data={dataResponse}
          setData={setDataResponse}
          columns={columns}
          loading={loading}
          textHeaderCard="chave"
          temInsert={true}
          insertOpenModal={handleOpenModalNew}
          handleDebounce={debouncedHandleChange}
        />


      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />
    </>
  );
};

export default Parametros;
